
Vue.asyncComponent('cms-publication-preview-item', {
    data() {
        return {
            modalVisibility: false,
            previewLinks: []
        }
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        active: {
            type: Boolean,
            required: false,
        },
        showArrow: {
            type: Boolean,
            required: false,
            default: true,
        },
        colorMode: {
            type: String,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        objectId: {
            type: String,
            required: true,
        },
    },
    watch: {
        previewLinks() {
            this.modalVisibility = this.previewLinks?.length > 1;
        }
    },
    methods: {
        /**
         * Close modal
         */
        closeModal() {
            this.modalVisibility = false;
        },
        /**
         * Get preview links
         * @return {Promise<void>}
         */
        async getPreviewLinks() {
            const path = this.$getSetting('paths.baseCms') + '/publication-preview-links/' + this.objectId;
            const result = await this.$get(path);

            this.previewLinks = result.links;

            // if only 1 link is returned we will open that link in a new tab
            if (this.previewLinks.length === 1) {
                window.open(this.previewLinks[0].href, '_blank').focus();
            }

            // else we will render a modal width all the links this is handled in the template
        }
    },
    mounted() {
        this.$on('setPreviewLinks', this.setPreviewLinks);
    }
}, 'cms/preview/cms-publication-preview-item.html');